export { default } from "./AuthRoute"


// WEBPACK FOOTER //
// ./src/components/AuthRoute/index.ts